(() => {
  if (customElements.get('sticky-header')) {
    return;
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('header');
      this.section = this.closest('.header-section');
      this.announcementBar = document.querySelector('announcement-bar');
      this.ticking = false;
      this.stuck = false;
    }

    connectedCallback() {
      if (!this.hasAttribute('enable-sticky')) {
        return;
      }

      this.section?.classList.add('is-scroll');
      this.measure();
      this.update();

      window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.measure.bind(this));
      window.addEventListener('load', this.measure.bind(this));
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.measure());
      }
    }

    // Reserva la altura del header expandido para que el contenido no salte al compactarse
    measure() {
      if (!this.section || this.stuck) return;
      const h = this.header.getBoundingClientRect().height;
      if (h > 0) this.section.style.setProperty('--hdr-expanded', Math.round(h) + 'px');
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const barHeight = this.announcementBar ? this.announcementBar.clientHeight : 0;
      const y = window.pageYOffset;

      // Histéresis: se compacta al pasar el aviso + 40px y se expande al volver casi arriba
      if (!this.stuck && y > barHeight + 40) {
        this.stuck = true;
      } else if (this.stuck && y <= barHeight + 4) {
        this.stuck = false;
      }
      this.section?.classList.toggle('is-stuck', this.stuck);

      if (y > barHeight) {
        this.header.classList.remove('header--transparent');
      } else if (
        this.header.hasAttribute('transparent') &&
        !this.header.hasAttribute('is-open')
      ) {
        this.header.classList.add('header--transparent');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);
})();
